import { AxiosStatic } from 'axios';

import { usePhoneCallStore } from 'src/stores/phoneCall';

import { AbstractPollingPhoneCallGatewayStrategy } from 'src/components/phoneCall/phoneCallGateway/AbstractPollingPhoneCallGatewayStrategy';
import { PollingPhoneCallGatewayStrategy } from 'src/components/phoneCall/phoneCallGateway/PollingPhoneCallGatewayStrategy';
import { sendGenericPostRequest } from 'src/components/phoneCall/phoneCallGateway/genericPostRequest/sendGenericPostRequest';

import { OutgoingCallConfigurationForTheUser } from 'src/models/phoneCall';

import { QueryStore } from 'src/util/query/QueryStore';

type PhoneCallStore = ReturnType<typeof usePhoneCallStore>;

export class GenericPostPollingPhoneCallGatewayStrategy
	extends AbstractPollingPhoneCallGatewayStrategy
	implements PollingPhoneCallGatewayStrategy
{
	private readonly axios: AxiosStatic;
	private readonly outGoingCallConfigurationForTheUser: OutgoingCallConfigurationForTheUser;

	constructor(
		axios: AxiosStatic,
		phoneCallStore: PhoneCallStore,
		queryStore: QueryStore,
		outgoingCallConfigurationForTheUser: OutgoingCallConfigurationForTheUser
	) {
		super(phoneCallStore, queryStore);
		this.axios = axios;
		this.outGoingCallConfigurationForTheUser = outgoingCallConfigurationForTheUser;
	}

	public async makeCall(_: string, toNumber: string): Promise<null | string> {
		const timestamp = String(Math.floor(Date.now() / 1000));

		await sendGenericPostRequest(this.axios, this.outGoingCallConfigurationForTheUser.url_init as string, {
			number: toNumber,
			terminal: this.outGoingCallConfigurationForTheUser.terminal,
		});

		return await this.nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp(toNumber, timestamp);
	}
}
